import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Form } from "react-bootstrap";
import { DebounceInput } from "react-debounce-input";

export default function BlackListParametros({
    parametros,
    alterarParametros,
    aoClicarEmCadastrar
}) {
    return (
        <div className="parametros">
            <div className="parametros-inicial">
                <DebounceInput 
                    placeholder="Ex.: xxxxxx@gmail.com" 
                    debounceTimeout={400}
                    element={Form.Control} 
                    value={parametros.texto}
                    onChange={e =>{
                        alterarParametros({
                            ...parametros, 
                            texto: e.target.value, 
                            pagina: 1
                        });
                    }}
                />
                <Button 
                    onClick={aoClicarEmCadastrar} 
                    variant={"padrao"} 
                    className={"botao-cadastrar"}
                >
                    <span>Cadastrar</span>
                    <FontAwesomeIcon
                        className="icone" 
                        icon={["fas", "plus"]} 
                    />
                </Button>
            </div>
        </div>
    )
}